import { Toaster as Sonner, type ToasterProps } from 'sonner';
import { useTheme } from '@/store/theme';

export function Toaster(props: ToasterProps) {
  const theme = useTheme((s) => s.theme);
  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-popover group-[.toaster]:text-popover-foreground group-[.toaster]:border-app-border group-[.toaster]:shadow-card',
          description: 'group-[.toast]:text-app-hint',
          actionButton:
            'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton:
            'group-[.toast]:bg-app-surface-2 group-[.toast]:text-app-text',
        },
      }}
      {...props}
    />
  );
}
